/**
 * Кнопка удаления с иконкой корзины. Единообразный вид во всех настройках.
 * Используется с ConfirmModal для подтверждения удаления.
 */
import React from 'react'
import { IconTrash } from './Icons'

export default function DeleteButton({ onClick, title, className = '', ariaLabel, ...rest }) {
  return (
    <button
      type="button"
      className={`settings-item-remove ${className}`.trim()}
      onClick={onClick}
      title={title}
      aria-label={ariaLabel ?? title}
      {...rest}
    >
      <IconTrash />
    </button>
  )
}
